var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',[(_vm.$route.meta.keeps)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keeps)?_c('router-view'):_vm._e(),_c('Tab',{directives:[{name:"show",rawName:"v-show",value:(this.$route.meta.hidden),expression:"this.$route.meta.hidden"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }